import React, { useEffect } from 'react';
import { Panel, Icon } from '../../components/ui';

// Centered confirmation for destructive actions. Escape, Cancel or the backdrop dismiss it.
export default function ConfirmDialog({ title, children, confirmLabel = 'Remove', busy, onConfirm, onCancel }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className="ops-drawer__backdrop" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }} onClick={onCancel}>
      <div role="dialog" aria-modal="true" aria-label={title} style={{ width: '100%', maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <Panel title={title} foot={(
          <div className="ops-actions" style={{ marginLeft: 'auto' }}>
            <button type="button" className="ops-btn" onClick={onCancel} disabled={busy}>Cancel</button>
            <button type="button" className="ops-btn ops-btn--danger" onClick={onConfirm} disabled={busy} autoFocus>
              <Icon name="trash" /> {busy ? 'Working...' : confirmLabel}
            </button>
          </div>
        )}>
          <div style={{ fontSize: 13.5, lineHeight: 1.6, color: 'var(--ink-2)' }}>{children}</div>
        </Panel>
      </div>
    </div>
  );
}
